import * as React from 'react';
import { useState } from 'react';

import { AuthService } from 'app/service/auth/auth-service';
import { useAppSelector } from 'app/hooks/redux-thunk';
import { ParamUtils } from 'app/utils/param-utils';
import { useAppNavigation } from 'app/utils/navigation-utils';
import { Spinner } from 'app/components/spinner';

const ProvAuthCallback = () => {
  const urlParamProvToken = ParamUtils.getQueryParam('provcustomertoken');
  const { provCustomerToken, sessionExpirationTimestamp } = useAppSelector((state) => state.auth);
  const [sessionExpTimestamp, setSessionExpTimestamp] = useState(-1);
  const { goToHomePage } = useAppNavigation();

  React.useEffect(() => {
    const sessionExpiration = Date.now() + 86400 * 1000; // 24H,
    setSessionExpTimestamp(sessionExpiration); // A control value, used to verify that redux store is updated before we redirect.
    AuthService.handleProvAuthorization(urlParamProvToken, sessionExpiration);
  }, []);

  React.useEffect(() => {
    if (urlParamProvToken === provCustomerToken && sessionExpirationTimestamp === sessionExpTimestamp) {
      // redux store finished updating Prov auth values. Ready to redirect.
      goToHomePage();
    }
  }, [provCustomerToken, sessionExpirationTimestamp]);

  return <Spinner marginVertical={true} />;
};

export { ProvAuthCallback };
